'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var isPoint = function (point) {
  return point.hasOwnProperty('x') && point.hasOwnProperty('y');
};

exports.isPoint = isPoint;
